module.exports = __webpack_public_path__ + "static/liznarova-7e69cf26c4a372c36ba292c6a6f0d4b1.jpg";